import React from "react";

const Categories = () => {
  return (
    <div className="bg-[#FCEBE9] max-w-[100vw] p-4 lg:px-4 mt-4">
      <div className="flex gap-2 items-start flex-wrap md:flex-nowrap">
        <div className="mt-2 text-[#E43625]">
          <svg
            width="34"
            height="17"
            viewBox="0 0 34 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
              fill="currentColor"
            />
            <path
              d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
              fill="currentColor"
            />
            <circle cx="25.5" cy="8.5" r="8.5" fill="currentColor" />
          </svg>
        </div>

        <div className="flex-1">
          <p className="text-[20px] font-semibold text-black text-left mb-6 uppercase">
            FORM NO 95 ( for Individuals) for citizen of Outside India (Foreign Citizens)
          </p>

          <div className="bg-white overflow-hidden shadow-sm rounded-lg border border-[#FAD7D3]">
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse text-[12px] md:text-[14px]">
                <thead className="bg-[#FAD7D3]">
                  <tr>
                    <th className="p-3 border border-gray-200 font-bold text-center" style={{ width: "20%" }}>Individuals not being a citizen of India</th>
                    <th className="p-3 border border-gray-200 font-bold text-center" style={{ width: "10%" }}>Form No. 95</th>
                    <th className="p-3 border border-gray-200 font-bold text-left">Documents as proof of identity, address and date of birth or date of incorporation</th>
                  </tr>
                </thead>
                <tbody className="text-[#4B4B4B]">
                  <tr>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-0">
                      <div className="p-2 border-bottom bg-gray-50 font-bold">(I) Proof of Identity:</div>
                      <div className="p-3">
                        <strong>(a)</strong> Copy of passport; or <br />
                        <strong>(b)</strong> Copy of person of Indian Origin card issued by the Government of India; or <br />
                        <strong>(c)</strong> Copy of Overseas Citizenship of India Card issued by Government of India; or <br />
                        <strong>(d)</strong> Copy of other national or citizenship Identification Number or Taxpayer Identification Number duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961) or by Indian embassy or High Commission or Consulate in the country where the applicant is located or authorised officials of overseas branches of Scheduled Banks registered in India.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-0 border-t border-gray-200">
                      <div className="p-2 border-bottom bg-gray-50 font-bold">(II) Proof of date of birth:</div>
                      <div className="p-3">
                        <strong>(a)</strong> Copy of passport; or <br />
                        <strong>(b)</strong> Copy of person of Indian Origin card issued by the Government of India; or <br />
                        <strong>(c)</strong> Copy of Overseas Citizenship of India Card issued by Government of India; or <br />
                        <strong>(d)</strong> Copy of other national or citizenship Identification Number or Taxpayer Identification Number containing date, month and year of birth duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961) or by Indian embassy or High Commission or Consulate in the country where the applicant is located or authorised officials of overseas branches of Scheduled Banks registered in India; or <br />
                        <strong>(e)</strong> Birth certificate issued by the municipal authority or any office authorised to issue birth and death certificate by the Registrar of Birth and Deaths or the Indian Consulate as defined in clause (d) of sub-section (1) of section 2 of the Citizenship Act, 1955 (57 of 1955); or <br />
                        <strong>(f)</strong> Copy of birth certificate containing date, month and year of birth issued by any foreign authority and duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961) or by Indian embassy or High Commission or Consulate in the country where the applicant is located or authorised officials of overseas branches of Scheduled Banks registered in India.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-3 border border-gray-200 text-center align-middle"></td>
                    <td className="p-0 border-t border-gray-200">
                      <div className="p-2 border-bottom bg-gray-50 font-bold">(III) Proof of address:</div>
                      <div className="p-3">
                        <strong>(a)</strong> copy of passport; or <br />
                        <strong>(b)</strong> Copy of person of Indian Origin card issued by the Government of India; or <br />
                        <strong>(c)</strong> Copy of Overseas Citizenship of India Card issued by Government of India; or <br />
                        <strong>(d)</strong> Copy of other national or citizenship Identification Number or Taxpayer Identification Number duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961), or by Indian embassy or High Commission or Consulate in the country where the applicant is located or authorised officials of overseas branches of Scheduled Banks registered in India; or <br />
                        <strong>(e)</strong> Copy of bank account statement in the country of residence; or <br />
                        <strong>(f)</strong> Copy of Non-resident External bank account statement in India; or <br />
                        <strong>(g)</strong> Copy of certificate of residence in India or Residential permit issued by the State Police Authority; or <br />
                        <strong>(h)</strong> Copy of the registration certificate issued by the Foreigner's Registration Office showing Indian address; or <br />
                        <strong>(i)</strong> Copy of visa granted and copy of appointment letter or contract from Indian Company and Certificate (in original) of Indian Address issued by the employer.
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;